(function(angular){
	'use strict';
	
	angular
		.module('verifyPasswordModule')
		.controller('VerifyPasswordController', [
			'$timeout',
			'globalConfig',
			'urlFactory',
			VerifyPasswordControllerFunction
		]);
	
	function VerifyPasswordControllerFunction(
		$timeout,
		globalConfig,
		urlFactory
	){
		var verifyPassword = this;

		verifyPassword.$onInit = function() {
			angular.extend(verifyPassword, globalConfig);
			if(verifyPassword.failedAttempt) {
				$timeout(function() {
					var incorrectPassword = {
						password: 'Password is not correct'
					};

					urlFactory.handleServerValidation(verifyPassword.verifyPasswordForm, urlFactory.spoofApiError(incorrectPassword));
				}, 100);
			}
		};
	}
})(window.angular);